import PropTypes from 'prop-types';
import { Map } from 'immutable';
import React from 'react';
import CheckoutController from '../../../event_components/Checkout';
import styles from './styles.scss';

const MobileCheckoutOnly = ({ event, settings, onResizeComponent }) => (
  <div className={styles.checkoutWrapper}>
    <CheckoutController variant="redesign" event={event} settings={settings} openTicketing onResizeComponent={onResizeComponent} />
  </div>
);

MobileCheckoutOnly.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default MobileCheckoutOnly;
